// src/Menu.js
import React, { useState, useEffect } from "react";
import "../src/Menu.css";
import Modal from "./Modal"; // Import the Modal component

const Menu = () => {
  const [menuData, setMenuData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [buttonDetail, setButtonDetail] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [hideButtons, setHideButtons] = useState(false); // Track button visibility
  const [isModalOpen, setIsModalOpen] = useState(false); // Track modal visibility

  useEffect(() => {
    // Fetch data from data.json
    fetch("/data.json") // Ensure path is correct
      .then((response) => response.json())
      .then((data) => setMenuData(data))
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleMenuClick = (id) => {
    const selected = menuData.find((item) => item.id === id);
    setSelectedItem(selected);
    setButtonDetail(null); // Reset button detail when a new section is clicked
    setSearchText(""); // Reset search text on tab change
    setHideButtons(false); // Show buttons when a new tab is selected
  };

  const handleButtonClick = (detail) => {
    setButtonDetail(detail); // Set the detail content for button click
    setHideButtons(true); // Hide buttons after clicking one
    setIsModalOpen(true); // Open the modal
  };

  // Function to filter content dynamically
  const filteredContent = selectedItem
    ? {
      title: selectedItem.title,
      content:
        selectedItem.content &&
          selectedItem.content.toLowerCase().includes(searchText.toLowerCase())
          ? selectedItem.content
          : "",
      example:
        selectedItem.example &&
          selectedItem.example.toLowerCase().includes(searchText.toLowerCase())
          ? selectedItem.example
          : "",
      buttons: selectedItem.buttons
        ? selectedItem.buttons.filter((button) =>
          button.label.toLowerCase().includes(searchText.toLowerCase())
        )
        : [],
    }
    : null;

  // Handle search field change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    // If search is cleared, show buttons again
    if (value === "") {
      setHideButtons(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  return (
    <div>
      {/* Menu Section */}
      <nav className="menu">
        <div className="top-search-section">
          <input
            type="text"
            value={searchText}
            onChange={handleSearchChange} // Use updated function
            placeholder="Search in this tab..."
            className="search-input"
          />
        </div>

        <ul className="menu-list">
          {menuData.length > 0 ? (
            menuData
              .sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase())) // Sort menu items by title in ascending order
              .map((item) => (
                <li className="menu-item" key={item.id}>
                  <button onClick={() => handleMenuClick(item.id)}>
                    {item.title}
                  </button>
                </li>
              ))
          ) : (
            <p>Loading menu...</p> // Negative case: If data is still loading
          )}
        </ul>
      </nav>

      {/* Content Section */}
      <div className="content">
        {selectedItem ? (
          <div>
            <h2>{filteredContent.title}</h2>

            {/* Search Section */}
            <div className="search-section">
              <input
                type="text"
                value={searchText}
                onChange={handleSearchChange} // Use updated function
                placeholder="Search in this tab..."
                className="search-input"
              />
            </div>

            {/* Render filtered buttons (Hide after clicking one) */}

            {!hideButtons && filteredContent.buttons.length > 0 ? (
              <div className="button-section">
                {filteredContent.buttons
                  .sort((a, b) => {
                    // Sorting by label in ascending order (case-insensitive)
                    return a.label.toLowerCase().localeCompare(b.label.toLowerCase());
                  })
                  .map((button, index) => (
                    <button
                      key={index}
                      onClick={() => handleButtonClick(button.detail)}
                      className="button-detail"
                    >
                      {button.label}
                    </button>
                  ))}
              </div>
            ) : buttonDetail ? null : (
              <p>No buttons available.</p> // Negative case: No buttons for the selected tab
            )}
          </div>
        ) : (
          <p>Please select a section from the menu to view content.</p> // Negative case: No section selected
        )}
      </div>

      {/* Modal Popup */}
      {isModalOpen && <Modal content={buttonDetail} onClose={closeModal} />}
    </div>
  );
};

export default Menu;
